<!-- Trending Courses -->
<div
    class="courses-area pt-100"
    [class.dark-courses-area]="themeService.isDark()"
>
    <div class="container">
        <div class="section-title text-center">
            <span class="sub-title" i18n>Discover New Blogs</span>
            <h2 i18n>Our Recent Blogs</h2>
            <a routerLink="/blogs" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span class="label" i18n>Read More</span><i class="bx bx-book-reader icon-arrow after"></i></a>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let blog of blogs">
                <div class="single-courses-box mb-30">
                    <div class="courses-image">
                        <a routerLink="/blogs/{{blog.id}}" class="d-block"><img src="{{imageUrl}}{{blog.images[0].url}}" style="max-height:18rem" alt="image"></a>
                    </div>
                    <div class="courses-content">
                        <div class="course-author d-flex align-items-center">
                                <i class='bx bx-user'></i> &nbsp;
                            <span>{{blog.author}}</span>
                        </div>
                        <h3><a routerLink="/blogs/{{blog.id}}" class="d-inline-block">{{blog.title}}</a></h3>
                        
                    </div>
                    <div class="courses-box-footer">
                        <ul>
                           
                            <li class=""><a i18n>{{blog.created_at | date:'longDate'}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
